var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88965 9.18428C1.88965 8.97162 2.06205 8.79922 2.27471 8.79922H5.90459C6.11725 8.79922 6.28965 8.97162 6.28965 9.18428V20.4142C6.28965 20.6268 6.11725 20.7992 5.90459 20.7992H2.65977C2.28965 20.7992 1.88965 20.3992 1.88965 20.0291V9.18428Z",
    fill: "#B6C6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27471 3.19922C4.06205 3.19922 3.88965 3.37162 3.88965 3.58428V19.5362C3.8058 20.4231 3.57729 20.7992 3.2041 20.7992H23.1046C23.3173 20.7992 23.4897 20.6268 23.4897 20.4142V3.58428C23.4897 3.37162 23.3173 3.19922 23.1046 3.19922H4.27471Z",
    fill: "#D0DBFB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.08984,
    y: 4.39844,
    width: 17.6,
    height: 4.4,
    fill: "#9DB2F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.08984,
    y: 14.7969,
    width: 8,
    height: 1.2,
    fill: "#9DB2F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6895,
    y: 10,
    width: 8,
    height: 1.2,
    fill: "#9DB2F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.08984,
    y: 10,
    width: 8,
    height: 4.4,
    fill: "#9DB2F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.08984,
    y: 16.3984,
    width: 8,
    height: 1.2,
    fill: "#9DB2F4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6895,
    y: 11.6016,
    width: 8,
    height: 1.2,
    fill: "#9DB2F4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.08984,
    y: 18,
    width: 8,
    height: 1.2,
    fill: "#9DB2F4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6895,
    y: 13.1992,
    width: 8,
    height: 1.2,
    fill: "#9DB2F4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6895,
    y: 16.3984,
    width: 8,
    height: 1.2,
    fill: "#9DB2F4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6895,
    y: 18,
    width: 8,
    height: 1.2,
    fill: "#9DB2F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeArticle);
export default __webpack_public_path__ + "static/media/tree-article.f7b04fcb.svg";
export { ForwardRef as ReactComponent };